import {
    CREATE_WAREHOUSE,
    DELETE_WAREHOUSE,
    GET_ALL_WAREHOUSE,
    GET_ID_WAREHOUSE,
    SEARCH_WAREHOUSE,
    UPDATE_WAREHOUSE,
    ASSIGN_USERS_WAREHOUSE,
    DELETE_USERS_WAREHOUSE,
    GET_WAREHOUSE_UNASSIGNED_USERS
} from '@/types/warehouseTypes';

// Initial state dengan proper structure
const initialState = {
    // Data states
    getAllWarehouse: { rows: [], count: 0, page: 1 },
    getIdWarehouse: null,
    searchWarehouse: { rows: [], count: 0 },
    createWarehouse: null,
    updateWarehouse: null,
    deleteWarehouse: false,
    getWarehouseUnassignedUsers: { rows: [], count: 0 },
    assignUsersWarehouse: false,
    deleteUsersWarehouse: false,

    // Loading states
    loading: {
        getAllWarehouse: false,
        getIdWarehouse: false,
        createWarehouse: false,
        updateWarehouse: false,
        deleteWarehouse: false,
        assignUsersWarehouse: false,
        deleteUsersWarehouse: false
    },

    // Error states
    errors: {
        getAllWarehouse: null,
        getIdWarehouse: null,
        createWarehouse: null,
        updateWarehouse: null,
        deleteWarehouse: null,
        assignUsersWarehouse: null,
        deleteUsersWarehouse: null
    }
};

const warehouseSlice = (state = initialState, action) => {
    switch (action.type) {
        // GET_ALL_WAREHOUSE
        case GET_ALL_WAREHOUSE:
            return {
                ...state,
                getAllWarehouse: action?.payload?.data || { rows: [], count: 0, page: 1 },
                loading: { ...state.loading, getAllWarehouse: false },
                errors: { ...state.errors, getAllWarehouse: action?.payload?.errorMessage || null }
            };

        // GET_ID_WAREHOUSE
        case GET_ID_WAREHOUSE:
            return {
                ...state,
                getIdWarehouse: action?.payload?.data || null,
                loading: { ...state.loading, getIdWarehouse: false },
                errors: { ...state.errors, getIdWarehouse: action?.payload?.errorMessage || null }
            };

        // CREATE_WAREHOUSE
        case CREATE_WAREHOUSE:
            return {
                ...state,
                createWarehouse: action?.payload?.data || null,
                loading: { ...state.loading, createWarehouse: false },
                errors: { ...state.errors, createWarehouse: action?.payload?.errorMessage || null }
            };

        // UPDATE_WAREHOUSE
        case UPDATE_WAREHOUSE:
            return {
                ...state,
                updateWarehouse: action?.payload?.data || null,
                loading: { ...state.loading, updateWarehouse: false },
                errors: { ...state.errors, updateWarehouse: action?.payload?.errorMessage || null }
            };

        // DELETE_WAREHOUSE
        case DELETE_WAREHOUSE:
            return {
                ...state,
                deleteWarehouse: action?.payload?.data || false,
                loading: { ...state.loading, deleteWarehouse: false },
                errors: { ...state.errors, deleteWarehouse: action?.payload?.errorMessage || null }
            };

        // SEARCH_WAREHOUSE
        case SEARCH_WAREHOUSE:
            return {
                ...state,
                searchWarehouse: action?.payload?.data || { rows: [], count: 0 },
                loading: { ...state.loading, searchWarehouse: false },
                errors: { ...state.errors, searchWarehouse: action?.payload?.errorMessage || null }
            };

        // ASSIGN_USERS_WAREHOUSE
        case ASSIGN_USERS_WAREHOUSE:
            return {
                ...state,
                assignUsersWarehouse: action?.payload?.data || false,
                loading: { ...state.loading, assignUsersWarehouse: false },
                errors: { ...state.errors, assignUsersWarehouse: action?.payload?.errorMessage || null }
            };

        // DELETE_USERS_WAREHOUSE
        case DELETE_USERS_WAREHOUSE:
            return {
                ...state,
                deleteUsersWarehouse: action?.payload?.data || false,
                loading: { ...state.loading, deleteUsersWarehouse: false },
                errors: { ...state.errors, deleteUsersWarehouse: action?.payload?.errorMessage || null }
            };

        // GET_WAREHOUSE_UNASSIGNED_USERS
        case GET_WAREHOUSE_UNASSIGNED_USERS:
            return {
                ...state,
                getWarehouseUnassignedUsers: action?.payload?.data || { rows: [], count: 0 },
                loading: { ...state.loading, getWarehouseUnassignedUsers: false },
                errors: { ...state.errors, getWarehouseUnassignedUsers: action?.payload?.errorMessage || null }
            };

        default:
            return state;
    }
};

export default warehouseSlice;
